import { TagSchema } from '../tags/tagsTypes';
export const INVOICE_ITEMS_REDUCER_KEY = 'invoiceItemsStore';
export type INVOICE_ITEMS_REDUCER_KEY = typeof INVOICE_ITEMS_REDUCER_KEY;

import z from 'zod';

import { ChartOfAccountSchema } from '../chart-of-accounts/chartOfAccountsTypes';
import type { QcsResourceSlice } from '../core/resourceSliceUtils';

export const InvoiceTypeSchema = z.enum([
  'NORMAL',
  'INVOICE_BILLABLE_EXPENSE',
  'INVOICE_BILLABLE_TIME',
  'INVOICE_BLANK_LINE',
  'INVOICE_BUNDLE',
  'INVOICE_DEPOSIT',
  'INVOICE_DISCOUNT',
  'INVOICE_ITEM_DISCOUNT',
  'INVOICE_ITEM_PRICE_RULE',
  'INVOICE_ITEM_SURCHARGE',
  'INVOICE_ITEM_TAX',
  'INVOICE_SHIPPING',
  'INVOICE_SHIPPING_TAX',
  'INVOICE_SUBTOTAL',
  'INVOICE_TAX',
  'INVOICE_TIP',
  'INVOICE_TAX_PRE_DISCOUNT',
  'LOAN_INTEREST',
  'LOAN_PRINCIPAL',
  'PAYCHECK_TBD',
  'UNKNOWN',
]);

export const GlobalItemTypeSchema = z.enum(['SERVICE', 'PRODUCT', 'INVENTORY', 'UNKNOWN']);

// https://bitbucket.org/quicken/qcs-fmcore-dtos/src/master/src/main/java/com/quicken/fmcore/dtos/ItemResource.java
export const InvoiceItemSchema = z
  .object({
    id: z.string(),
    clientId: z.string(),
    createdAt: z.string(),
    modifiedAt: z.string(),
    name: z.string(),
    coa: ChartOfAccountSchema,
    tags: z.array(TagSchema),
    description: z.string(),
    memo: z.string(),
    type: InvoiceTypeSchema.catch('UNKNOWN'),
    itemType: GlobalItemTypeSchema.catch('UNKNOWN'),
    cost: z.number(),
    reorderPoint: z.number(),
    position: z.number(),
    parentItemId: z.string(),
    parentItemClientId: z.string(),
    units: z.number(),
    rate: z.number(),
    isDeleted: z.boolean(),
    isTaxable: z.boolean(),
    isArchived: z.boolean(),
    isPercentageOfPrevItem: z.boolean(),
  })
  .partial();

export type InvoiceItemType = z.infer<typeof InvoiceItemSchema>;
export type GlobalItemType = z.infer<typeof GlobalItemTypeSchema>;

export type InvoiceItemsState = QcsResourceSlice<InvoiceItemType>;

declare module 'app-components/utils/redux-store/rootState' {
  export default interface RootState {
    [INVOICE_ITEMS_REDUCER_KEY]: InvoiceItemsState;
  }
}
